import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { LocalRepository } from '@shared/helper/local-repository';

@Component({
  selector: 'app-prompt-bottomsheet',
  templateUrl: './prompt-bottomsheet.component.html',
  styleUrls: ['./prompt-bottomsheet.component.scss'],
  imports: [
    CommonModule,
    MatButtonModule,
  ]
})
export class PromptBottomsheetComponent implements OnInit {
  private _localRepository = inject(LocalRepository);
  private _bottomSheetRef = inject<MatBottomSheetRef<PromptBottomsheetComponent>>(MatBottomSheetRef);
  _data = inject<{
    mobileType: number;
    promptEvent?: any;
  }>(MAT_BOTTOM_SHEET_DATA);

  isAndroid = false;

  ngOnInit() {
    this._data?.mobileType == 1 ? this.isAndroid = true : this.isAndroid = false;
  }

  public installPwa(): void {
    this._data?.promptEvent?.prompt();
    this.close();
  }

  public close() {
    if (this._localRepository.IsInBrowser) {
      this._localRepository.setLocalItem('PWA', Date.now().toString())
    }
    this._bottomSheetRef.dismiss();
  }

}
